import { InlineButtonBadgeTypes } from '../types/index.js';
import { BadgeTypes } from '../../Badge/types/index.js';

const badgeData = {
    [InlineButtonBadgeTypes.Premium]: BadgeTypes.Premium,
    [InlineButtonBadgeTypes.Verified]: BadgeTypes.Verified,
    [InlineButtonBadgeTypes.Star]: BadgeTypes.Star,
    [InlineButtonBadgeTypes.Ambassador]: BadgeTypes.Ambassador,
    [InlineButtonBadgeTypes.MasterContributor]: BadgeTypes.MasterContributor,
    [InlineButtonBadgeTypes.MasterStoryteller]: BadgeTypes.MasterStoryteller,
    [InlineButtonBadgeTypes.Dot]: BadgeTypes.Dot,
    [InlineButtonBadgeTypes.DotPremium]: BadgeTypes.DotPremium,
    [InlineButtonBadgeTypes.New]: BadgeTypes.New,
    [InlineButtonBadgeTypes.NewPremium]: BadgeTypes.NewPremium,
    [InlineButtonBadgeTypes.Try]: BadgeTypes.Try,
    [InlineButtonBadgeTypes.TryPremium]: BadgeTypes.TryPremium,
    [InlineButtonBadgeTypes.Beta]: BadgeTypes.Beta,
    [InlineButtonBadgeTypes.AiRectangle]: BadgeTypes.AiRectangle,
    [InlineButtonBadgeTypes.AiCircle]: BadgeTypes.AiCircle,
    [InlineButtonBadgeTypes.Plus]: BadgeTypes.Plus,
    [InlineButtonBadgeTypes.Pro]: BadgeTypes.Pro,
    [InlineButtonBadgeTypes.Like]: BadgeTypes.Like,
    [InlineButtonBadgeTypes.Follow]: BadgeTypes.Follow,
    [InlineButtonBadgeTypes.Comment]: BadgeTypes.Comment,
    [InlineButtonBadgeTypes.Replay]: BadgeTypes.Replay,
    [InlineButtonBadgeTypes.NewPost]: BadgeTypes.NewPost,
    [InlineButtonBadgeTypes.Save]: BadgeTypes.Save,
    [InlineButtonBadgeTypes.Tag]: BadgeTypes.Tag,
    [InlineButtonBadgeTypes.Mention]: BadgeTypes.Mention,
    [InlineButtonBadgeTypes.Remix]: BadgeTypes.Remix,
    [InlineButtonBadgeTypes.Sticker]: BadgeTypes.Sticker,
    [InlineButtonBadgeTypes.Challenges]: BadgeTypes.Challenges,
    [InlineButtonBadgeTypes.Admin]: BadgeTypes.Admin,
    [InlineButtonBadgeTypes.FileShare]: BadgeTypes.FileShare,
    [InlineButtonBadgeTypes.FileJoined]: BadgeTypes.FileJoined,
    [InlineButtonBadgeTypes.PlusCrown]: BadgeTypes.PlusCrown,
    [InlineButtonBadgeTypes.ProCrown]: BadgeTypes.ProCrown,
    [InlineButtonBadgeTypes.Gold]: BadgeTypes.Gold,
    [InlineButtonBadgeTypes.PlusReverse]: BadgeTypes.PlusReverse,
    [InlineButtonBadgeTypes.ProReverse]: BadgeTypes.ProReverse,
    [InlineButtonBadgeTypes.GoldReverse]: BadgeTypes.GoldReverse,
    [InlineButtonBadgeTypes.Free]: BadgeTypes.Free,
    [InlineButtonBadgeTypes.AiAvatar]: BadgeTypes.AiAvatar,
    [InlineButtonBadgeTypes.ProTrial]: BadgeTypes.ProTrial,
    [InlineButtonBadgeTypes.PlusTrial]: BadgeTypes.PlusTrial,
    [InlineButtonBadgeTypes.CrownTrial]: BadgeTypes.CrownTrial,
};

export { badgeData };
